// extracted by mini-css-extract-plugin
export default {"panelContent":"panelContent__wRg2Wm"};